import json from './config.json';

export const config = () => {
  const env = process.env.NODE_ENV;
 // console.log("env", json[env])
  return json[env]
  // if(env == 'development'){
  //   console.log("env111", process.env.NODE_ENV)
  //   return json[env]
  // }else if(env == 'prod'){
  //   console.log("env222", env)
  //   return prod_env
  // }
}
